// extracted by mini-css-extract-plugin
export default {"resendButton":"wFHLINCsOxd3C47V5gcn"};